<div class="remove-machine-mode-modal">
  <div class="machine-modal-header">
    <span>{{'machine_mode_conflict' | translate}}</span>
    <img src="../../../assets/icon/cancel.svg" alt="" class="close-icon" (click)="closeModal()">
  </div>
  <div class="modal-body">
    <p>
      {{'machine_mode_conflict_msg' | translate}}
    </p>
    <div class="column-header-container">
      <span class="column-header">{{'importing_from_roadmap' | translate}}</span>
      <span class="column-header">{{'current_machine_modes' | translate}}</span>
    </div>
    <div class="machine-mode-conflict-container">
      <div class="left">
        <div class="capsule-list">
          <button *ngFor="let mode of newModes" class="capsule" [ngClass]="{ 'not-found': mode.isNotFound }">
            {{ mode.modeName }}
          </button>
        </div>
      </div>
      <div class="right">
        <div class="capsule-list">
          <button *ngFor="let mode of currentModes" class="capsule">
            {{ mode.modeName }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="warning-text">
    {{'confirm_import' | translate}}
  </div>
  <div class="modal-footer">
    <ion-button class="app-btn" shape="round" fill="outline" color="primary" (click)="closeModal()">
      {{'Cancel'|translate}}
    </ion-button>
    <ion-button class="app-btn" shape="round" fill="outline" color="primary" (click)="import()">
      {{'sync_import'|translate}}
    </ion-button>
  </div>
</div>